import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";
import { payrollPeriodService } from "./payrollPeriodService";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const leaveEncashmentService = {
  getLeaveBalances: async (param) => {
    const payload = { 
      filters: param.apiFilterPayload, 
      year: param.currentYear,
      isPostedForCurrentPayroll: param?.isPostedForCurrentPayroll ?? false,
      payrollPeriodId: param?.currentPayrollPeriodId ?? null,
    };
    return await axios.post(`${domain}/api/LeaveEncashment/preview`, payload, { headers });
  },

  syncToPayroll: async (param) => {
    const payload = { 
      employeeIds: param.employeeIds, 
      payrollPeriodId: param.payrollPeriodId, 
      year: param.year,
      classificationId: param.classificationId 
    };
    return await axios.post(`${domain}/api/LeaveEncashment/sync-to-payroll`, payload, { headers });
  },

  syncToFinalPay: async (employeeIds, payrollPeriodId, year) => {
    const payload = { employeeIds, payrollPeriodId, year };
    return await axios.post(`${domain}/api/LeaveEncashment/sync-to-final-pay`, payload, { headers });
  },

  revert: async (payrollPeriodId, classificationId, isFinalPay) => {
    const payload = { payrollPeriodId, classificationId, isFinalPay };
    return await axios.post(`${domain}/api/LeaveEncashment/revert`, payload, { headers });
  },

};